import React from 'react';
import { Card } from "react-bootstrap";
import face_botond_szilagyi from "../../assets/img/9.png";
import ShowMoreText from "react-show-more-text";
import proj_pixel from "../../assets/img/proj_pixel_SzilagyiB.png";

const Botond_Szilagyi_pixel = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_pixel} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_botond_szilagyi}
              /* this will be the text on the banner */
              alt="Pixels to Particles: AI-Powered Segmentation in Pharmaceutical Imaging"
            />{" "}
            <p className="text7">Botond Szilágyi</p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            <p className="text8">Department of Chemical and Environmental Process Engineering, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In the pharmaceutical industry, liquid-solid dispersed systems-such as crystals formed during crystallization, 
            play a critical role. The bioavailability of the active ingredient depends on the particle size, shape, surface 
            roughness, polymorphism and the degree of aggregation of the particles. Inadequate particle properties may prevent 
            proper dissolution in the bloodstream, leading to drug excretion without therapeutic effect; the Ritonavir tablet 
            is a classical example of this phenomenon. Our research group operates an in-line microscope capable of recording 
            high-resolution (14-bit) images inside the reactor at sampling frequencies up to 60 Hz. The suspended particles are 
            often transparent, posing a major challenge to conventional image processing approaches, including most CNN-based 
            methods. The aim of this project is to apply and fine-tune mathematical and computational image processing methods, 
            focusing on two key tasks:
            <ol>
                <li>
                    Segmentation, multidimensional particle size distribution calculation and in-depth comparative study:
                    <ul>
                        <li>
                            Detecting particles and generating masks using state-of-the-art neural networks, such as U-Net, Mask R-CNN, StarDist, Cellpose, and Segment Anything Model (SAM), YOLOv8 and AI Vision
                        </li>
                        <li>
                            Computing particle length and width distributions, and full 2D distribution. Comparison with ground-truth (manual and automatic offline image analysis).
                        </li>
                        <li>
                            Adjusting the image analysis parameters to match the ground-truth, and validation of the optimal settings on unseen images.
                        </li>
                    </ul>
                </li>
                <li>
                    Classification and in-depth comparative study:
                    <ul>
                        <li>
                            Assigning particles to polymorphic classes based on size, shape, and surface properties
                        </li>
                        <li>
                            Identifying and quantifying particle aggregation levels (e.g., distinguish between agglomerate and single particle).
                        </li>
                        <li>
                            Applying open-source ML frameworks (PyTorch, TensorFlow) and modern platforms such as MetaAI Vision and Google Vertex AI to optimize clustering and classification in the above tasks;
                        </li>
                        <li>
                            Evaluating imaging-based polymorph content measurement performance against experimental ground truth, i.e., RAMAN laser measurements of polymorphic contents during a crystallization process.
                        </li>
                    </ul>
                </li>
            </ol>
            Students will adapt, fine-tune, and benchmark open-source image processing and AI tools in python using laboratory experiments from BME/VBK 
            as input, in collaboration with chemical engineering students. The results will be integrated into the process model identification workflow 
            of the ChemE research group and reported directly to the equipment manufacturer.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Botond_Szilagyi_pixel;